// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, oneOf, string } from 'prop-types'
import ModalWrapper from './ModalWrapper'
import { useBooleanToggle } from 'hooks'
import LookupTrigger from './LookupTrigger'

const Lookup = props => {
  const {
    className,
    disabled,
    includeFlags,
    lookupFormName,
    getLookupTypeProps,
    lookupLabel,
    lookupType,
    paginate,
    queryBasis,
    selectRow,
    triggerId,
    unitType,
  } = props

  const [isOpen, toggleIsOpen] = useBooleanToggle()

  return (
    <div className={className}>
      <LookupTrigger
        disabled={disabled}
        id={triggerId}
        lookupType={lookupType}
        toggleIsOpen={toggleIsOpen} />
      {
        isOpen &&
        <ModalWrapper
          closeModal={toggleIsOpen}
          formName={lookupFormName}
          getLookupTypeProps={getLookupTypeProps}
          includeFlags={includeFlags}
          label={lookupLabel}
          lookupType={lookupType}
          paginate={paginate}
          queryBasis={queryBasis}
          selectRow={selectRow}
          unitType={unitType} />
      }
    </div>
  )
}

Lookup.displayName = 'Lookup'

Lookup.propTypes = {
  className: string,
  disabled: bool,
  getLookupTypeProps: func.isRequired,
  lookupFormName: string.isRequired,
  lookupLabel: string.isRequired,
  lookupType: string.isRequired,
  includeFlags: array,
  queryBasis: array,
  paginate: bool,
  selectRow: func.isRequired,
  triggerId: string.isRequired,
  unitType: oneOf([
    'SI',
    'US',
  ]),
}

Lookup.defaultProps = {
  className: 'lookup-component',
}

export default Lookup
